import { takeLatest, call, put, select, } from "redux-saga/effects"
import moment from 'moment'


import { fetchPricingLoads, fetchComparableLoad, updateLoadPricing } from '../pricingLoadActions'
import { ADD_MESSAGE, FETCH_EXERNAL_LOADS_FOR_LOAD, FETCH_PRICING_LOADS, FETCH_SELECTED_PRICING_LOAD, PRICING_EVENT, SET_BIDS, SET_EXTERNAL_LOADS, SET_HISTORICAL_LOADS, SET_PRICING_LOADS, SET_SELECTED_PRICING_LOAD, UPDATE_PRICING_LOAD, UPDATE_PRICING_LOAD_CHANGES } from "../actionTypes"
import { getBids, getPricingLoads, getSelectedPricingLoad } from "../rootReducer"
import { datRatesByLoadId, fetchLoadBids } from "../loadActions"

function* workerFetchPricingLoads(payload) {
  const filter = payload.filter || {}

  try {
    // this sets the loads to show a loading screen
    yield put({ type: SET_PRICING_LOADS, loads: null })

    const response = yield call(fetchPricingLoads, filter)

    //TODO: should clear out selected pricing load along with the load history and the market loads
    if (response.status === 200) {
      yield put({ type: SET_PRICING_LOADS, loads: response.data })
    } else {
      yield put({ type: SET_PRICING_LOADS, loads: [] })
    }

  } catch (exc) {
    console.error('workerFetchPricingLoads', exc)
    // clear out the load screen
    yield put({ type: SET_PRICING_LOADS, loads: [] })
  }
}

function* workerFetchSelectedPricingLoad(payload) {
  const load = payload.load
  const currentLoad = yield select(getSelectedPricingLoad)
  try {

    if (load?.id && (load?.id !== currentLoad?.id)) {

      if (!load.lane_rate) {
        const lrResponse = yield call(datRatesByLoadId, load.id)
        console.log(lrResponse?.data)
        if (lrResponse.data) {
          load.lane_rate = {
            total_rate_low: lrResponse.data.low_lh_total,
            total_rate: lrResponse.data.estimated_lh_total,
            total_rate_high: lrResponse.data.high_lh_total,
          }
          yield put({ type: UPDATE_PRICING_LOAD, load })
        }
      }
      yield put({ type: SET_BIDS, bids: [] })
      yield put({ type: SET_HISTORICAL_LOADS, loads: [] })
      yield put({ type: SET_SELECTED_PRICING_LOAD, load })
      yield put({ type: SET_EXTERNAL_LOADS, loads: [] })
      if (load) {
        const comparablesResult = yield call(fetchComparableLoad, load)
        yield put({ type: SET_HISTORICAL_LOADS, loads: comparablesResult.data || [] })
        yield put({ type: FETCH_EXERNAL_LOADS_FOR_LOAD, load: load })

        const bidsResponse = yield call(fetchLoadBids, load)
        if (bidsResponse?.data) {
          yield put({ type: SET_BIDS, bids: bidsResponse.data })
        }
      }
    }
  } catch (exc) {
    console.error('workerFetchSelectedPricingLoad', exc)
  }

}

function* workerLoadPricingEvent(payload) {
  try { 
    const evt = payload.data

    if (evt.event_type === 'LOAD') {
      //Note: This only updates loads in the sheet.  You need to requery to get load new loads
      let load = evt.subject

      const pricingLoads = yield select(getPricingLoads)
      const pricingLoad = pricingLoads.find(l => l.id === load.id)
      if (pricingLoad) {
        if (load.status !== 'OPEN') {
          const updatedLoads = pricingLoads.filter(l => l.id !== load.id)
          yield put({ type: SET_PRICING_LOADS, loads: updatedLoads })
        }
      }
    } else if (evt.event_type === 'BID') {
    
      const bid = evt.subject
      const pricingLoads = yield select(getPricingLoads)
      const pricingLoad = pricingLoads.find(l => l.id === bid.load_id)
      if (pricingLoad) {
        const isUpdated = ['BID', 'HOLD', 'DECLINE'].includes(bid.status)
  
        let bid_field = 'bid_count'
        if (bid.status === 'HOLD') {
          bid_field = 'hold_count'
        } else if (bid.status === 'DECLINE') {
          bid_field = 'decline_count'
        }
        if (bid.void) {
          if (pricingLoad.bid_summary[bid_field]) {
            pricingLoad.bid_summary[bid_field]--
          }
        } else {
          pricingLoad.bid_summary[bid_field]++
        }
        if (isUpdated) {
          pricingLoad.updated_at = moment().toISOString()
          pricingLoad.bid_summary.last_bid_date = bid.created_at
          const updatedLoads = pricingLoads.filter(l => l.id !== pricingLoad.id)
          updatedLoads.push(pricingLoad)
          yield put({ type: SET_PRICING_LOADS, loads: updatedLoads })
        }
        const selectedPricingLoad = yield select(getSelectedPricingLoad)
        if (selectedPricingLoad?.id === bid.load_id) {
          const bids = yield select(getBids)

          const updatedBids = [...bids, bid]
          yield put({ type: SET_BIDS, bids: updatedBids })
        }
      }
    }
  } catch (exc) {
    console.error('workerFetchSelectedPricingLoad', exc)
  }
}

function* workerUpdatePricingLoadChanges(payload) {
  const { changes } = payload
  const selectedPricingLoad = yield select(getSelectedPricingLoad)

  const response = yield call(updateLoadPricing, changes)

  if (response.data) {
    for (let load of response.data) {
      yield put({ type: UPDATE_PRICING_LOAD, load })
      if (selectedPricingLoad && (selectedPricingLoad.id === load.id)) {
        yield put({ type: SET_SELECTED_PRICING_LOAD, load: load })
      }
    }
  }

  yield put({ type: ADD_MESSAGE, message: 'Load Pricing save complete' })
}

export function* watchFetchPricingLoadsSaga() {
  yield takeLatest(FETCH_PRICING_LOADS, workerFetchPricingLoads)
}

export function* watchFetchSelectedPricingLoadSaga() {
  yield takeLatest(FETCH_SELECTED_PRICING_LOAD, workerFetchSelectedPricingLoad)
}

export function* watchUpdatePricingLoadChangesSaga() {
  yield takeLatest(UPDATE_PRICING_LOAD_CHANGES, workerUpdatePricingLoadChanges)
}

export function* watchLoadPricingEventSaga() {
  yield takeLatest(PRICING_EVENT, workerLoadPricingEvent)
}
//TODO: add in select Pricing Load which will pull the historic pricing load data and the market, if the pickkup date is within 2 days